import RegisterForm from 'components/RegisterForm/RegisterForm';

const RegisterPage = () => {
  return <RegisterForm />;
};

export default RegisterPage;
